import { RouteNavigate, type RoutePath, useBaseNavigate } from "@modules/navigation/hooks/useBaseNavigate"
import { Path } from "@modules/navigation/routes"
import { type NavigateOptions } from "react-router"

export const useMySpaceNavigate = () => {
  const navigate = useBaseNavigate()
  return (path: RoutePath, options?: NavigateOptions) => navigate(path, getMySpacePath, options)
}

export const getMySpacePath = (path: Omit<RoutePath, RouteNavigate.Back>) => {
  if (path === RouteNavigate.Root) {
    return Path.MySpace.Root
  } else {
    return `${Path.MySpace.Root}/${String(path)}`
  }
}
